import { render, staticRenderFns } from "./board_model.vue?vue&type=template&id=66011ce2&scoped=true"
import script from "./board_model.vue?vue&type=script&lang=js"
export * from "./board_model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66011ce2",
  null
  
)

export default component.exports